// extracted by mini-css-extract-plugin
export default {"terminal":"Terminal__terminal___kD-nP","terminal-display":"Terminal__terminal-display___CIFZt"};